import React, { useRef } from 'react';
import uploadLogo from '../assets/upload.svg';
import video from '../assets/video.png';
import trashIcon from '../assets/trash.svg';
import PublicationImageWithLogo from '../components/PublicationImageWithLogo';

interface UploadFileProps {
    handleMediaChange: (e: React.ChangeEvent<HTMLInputElement>, networkKey?: string) => void;
    resetMedia: (networkKey?: string) => void;
    disabled: boolean;
    media: string;
    extension: string;
    networkKey?: string;
    isGlobal?: boolean;
    isViewMode?: boolean;
}
const trash = { path: trashIcon };

const UploadFile: React.FC<UploadFileProps> = ({
    handleMediaChange,
    extension,
    resetMedia,
    disabled,
    media,
    networkKey,
    isGlobal = false,
    isViewMode = false,
}) => {
    const inputFile = useRef<HTMLInputElement>(null);

    if (isViewMode && !media) {
        return null;
    }

    return (
        <>
            <div className="flex flex-col items-center content-center justify-evenly w-full h-[300px] bg-primary-light border border-dashed border-dark-gray rounded-[5px] overflow-hidden relative font-montserrat">
                {!media && (
                    <>
                        <img src={uploadLogo} width="32" height="32" alt="upload-logo" />
                        <span className="relative z-10 text-medium font-medium">
                            Déposer vos fichiers ici
                        </span>
                        <span className="relative z-10 text-medium">ou</span>
                        <span className="flex rounded-[24px] p-[12px] bg-white border border-light-gray text-medium font-small cursor-pointer">
                            Ajouter un fichier
                        </span>
                        <span className="flex text-small">
                            {networkKey !== 'googleMyBusiness'
                                ? '10Mo max, .jpg, .mp4 acceptés'
                                : '10Mo max, .jpg acceptés'}
                        </span>
                    </>
                )}
                {!isViewMode && (
                    <input
                        ref={inputFile}
                        name="media"
                        id={networkKey || 'basePublication'}
                        type="file"
                        className="flex opacity-0 absolute w-full h-full top-0 left-0 z-10 cursor-pointer"
                        accept={
                            networkKey !== 'googleMyBusiness'
                                ? 'image/jpeg, image/jpg, video/mp4'
                                : 'image/jpeg, image/jpg'
                        }
                        onChange={e => handleMediaChange(e, networkKey)}
                        onClick={e => e.stopPropagation()}
                        multiple={false}
                        disabled={disabled}
                    />
                )}
                {media && (
                    <div className="absolute inset-0 w-full h-full bg-light-gray z-[100]">
                        {!isViewMode && (
                            <button
                                className="absolute top-[12px] right-[12px] w-[32px] h-[32px] bg-white rounded-[4px] m-0 p-0 z-[101] flex items-center justify-center"
                                onClick={e => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    resetMedia(networkKey);
                                }}
                            >
                                <img
                                    src={trash.path}
                                    alt="trash icon"
                                    className="w-4 h-4"
                                    aria-hidden="true"
                                />
                            </button>
                        )}
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <PublicationImageWithLogo
                                imageUrl={extension === 'mp4' ? video : media}
                                alt={media}
                                className=""
                                isGlobal={isGlobal}
                                showLogo={true}
                                extension={extension}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default UploadFile;
